import { Button } from 'antd';
import React, { useContext, useEffect, useState } from 'react';

import SectionContainer from './section-container';
import useWidth from '@/helpers/widthUtil';
import { MockTestContext } from '../..';
const SectionCollections = ({
  listenFromHere,
  data,
  scrollToQn,
  setAns,
  answers,
  setAnswer,
  section,
  testStarted,
  count,
}) => {
  const { isMobile } = useWidth();
  const { submit } = useContext(MockTestContext);

  const [newSection, setSection] = useState(data?.data?.section);

  useEffect(() => {
    var section = data?.data?.section;
    var section_no = 1;
    section?.forEach((s) => {
      s.section_no = section_no;
      s.title = s.title;
      s.marks = s.marks;
      s.total_q = s.question.length;
      s.total_marks = s.total_q * s.marks;
      var from = s.question_from;
      var to = s.question_to;
      var q_no = from;
      s.question.forEach((q) => {
        q.q_no = q_no;
        q_no = q_no + q.no_answer;
        if (q.question_type != 3)
          setAns((prevans) => [
            ...prevans,
            { section_id: s.id, model_id: data.data.id, question_id: q.id },
          ]);
      });
      section_no = section_no + 1;
    });
    setSection(section);
  }, [data?.data?.section]);

  return (
    <div className="section-collection">
      {newSection?.map((s) => (
        <SectionContainer
          key={s?.id}
          section={s}
          model={data.data.id}
          listenFromHere={listenFromHere}
          scrollToQ={scrollToQn}
          answers={answers}
          setAns={setAns}
          setAnswer={setAnswer}
        />
      ))}
      <div className={`text-center ${isMobile ? 'mb-4' : 'mb-5'}`}>
        <h5 className="text-primary text-bold">End of the Test</h5>
      </div>
      {testStarted && (
        <div
          className="question-palette__footer-button-container text-center mt-1"
          style={{ marginBottom: isMobile ? '5.5rem' : '0.25rem' }}
        >
          <Button
            className="ant-btn ant-btn-default btn-secondary border-danger"
            onClick={submit}
          >
            Submit Test
          </Button>
        </div>
      )}
    </div>
  );
};
export default SectionCollections;
